import { FORECAST, PLANNER } from "../pageModes";
import buildInitialModel from "./buildInitialModel";
import { getForecastColumns, getPlannerColumns } from "./util/getColumns";
import { setGroupingTotalFteSum } from "./updateIntersectingFteSumForDateRanges";

const getColumnsForPageMode = (allocationProjects, pageMode) => {
  if (pageMode === PLANNER) {
    return getPlannerColumns(allocationProjects || []);
  }

  if (pageMode === FORECAST) {
    return getForecastColumns(allocationProjects || []);
  }

  return [];
};

export const demandRequestSummariesToMacroAllocations = (summaries = []) => {
  return summaries.map((summary) => ({
    id: summary.id,
    allocationProjectId: summary.allocationProjectId,
    targetGroupId: summary.demandGroupId,
    sourceGroupId: summary.supplyGroupId,
    forecast: summary.effectiveFte,
    requestSubmitted: summary.effectiveFte,
    allocatedMemberFte: summary.scheduledFte,
    realtimeCurrentMemberFte: summary.scheduledFte,
    demandRequestSummary: summary,
  }));
};

export default (
  state,
  {
    demandRequests,
    demandRequestGroups,
    demandRequestSummaries,
    allocationProjects,
    pageMode,
    viewMode,
    data,
  }
) => {
  const macroAllocations = demandRequestSummariesToMacroAllocations(
    demandRequestSummaries
  );

  const demandRequestModel = buildInitialModel({
    mainQueryData: {
      ...data,
      macroAllocationGroups: demandRequestGroups || [],
      macroAllocations,
    },
    viewMode,
    pageMode,
    rootGroup: state.rootGroup,
    groupTypes: state.groupTypes,
    approvalReasons: state.approvalReasons,
    hideHiddenTeams: state.hideHiddenTeams,
    showObjectives: state.showObjectives,
    shouldHash: true,
    isBudgetEnabled: state.isBudgetEnabled,
    useDeltaForBudget: state.useDeltaForBudget,
    overBudgetLimit: state.overBudgetLimit,
    underBudgetLimit: state.underBudgetLimit,
    isRealtimeFteMode: state.isRealtimeFteMode,
    useRealtimeChangeOnly: state.useRealtimeChangeOnly,
    useRealtimeFteDelta: state.useRealtimeFteDelta,
    enableDemandRequest: state.enableDemandRequest,
    enableDemandRollupPlanning: state.enableDemandRollupPlanning,
    enableSupplyForecastTargets: state.enableSupplyForecastTargets,
  });

  demandRequestModel.groupings?.forEach((grouping) => {
    setGroupingTotalFteSum(grouping, demandRequestModel.columns);
  });

  return {
    ...state,
    demandRequests: demandRequests || [],
    demandRequestGroups: demandRequestGroups || [],
    demandRequestSummaries: demandRequestSummaries || [],
    dynamicModel: demandRequestModel,
  };
};
